import CircleI from './src/circle-i-combined';
export default CircleI;